var map = {
	"./icon_back.svg": "f7e0",
	"./icon_bank_back.svg": "664f",
	"./icon_btc.svg": "89c5",
	"./icon_ccf.svg": "8529",
	"./icon_ccm.svg": "a632",
	"./icon_check.svg": "e7ce",
	"./icon_end.svg": "9fea",
	"./icon_eos.svg": "d764",
	"./icon_eth.svg": "8bdb",
	"./icon_filter.svg": "a139",
	"./icon_focus_check.svg": "ad7e",
	"./icon_join.svg": "12fe",
	"./icon_jpy.svg": "8f12",
	"./icon_krw.svg": "ae7b",
	"./icon_login.svg": "2e18",
	"./icon_logout.svg": "b585",
	"./icon_main_about.svg": "3d9c",
	"./icon_main_bank.svg": "2a8f",
	"./icon_main_market.svg": "2763",
	"./icon_main_order.svg": "5437",
	"./icon_newplus.svg": "d516",
	"./icon_ok.svg": "c2b0",
	"./icon_plus_blue.svg": "311c",
	"./icon_plus_green.svg": "b27c",
	"./icon_refresh.svg": "d8bd",
	"./icon_search.svg": "2363",
	"./icon_steem.svg": "9125",
	"./icon_trade.svg": "6810",
	"./icon_usdt.svg": "016e",
	"./icon_warning.svg": "6b35",
	"./icon_xmr.svg": "a132"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5166";